/**
 * Converts a string to camel case.
 * (Also removes any non-alphanumeric characters)
 *
 * @param {string} string - The string to convert.
 * @returns {string} The camel case version of the string.
 */
export function formatToCamelCase(string: string) {
	return string
		.replace(/[^a-z0-9]+/gi, ' ')
		.split(' ')
		.map((word: string, index: number) => {
			if (index === 0) {
				return word.toLowerCase();
			} else {
				return capitalizeFirstLetter(word);
			}
		})
		.join('');
}

export function capitalizeFirstLetter(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
